
import React from 'react';
import { ReactComponent as Edit } from 'src/images/edit.svg'
import { ReactComponent as Trash } from 'src/images/trash.svg'
import './ActionButtons.scss'


 const ActionButtons = ({ onEditClick: editClick, onDeleteClick: deleteClick }) => {

  const onEditClick = (e) => {
    e.stopPropagation();
    if (editClick) editClick()
  }

  const onDeleteClick = (e) => {
    e.stopPropagation();
    if (deleteClick) deleteClick()
  }

  return (
    <div className='action-buttons button-container'>
      <Edit onClick={onEditClick} />
      <Trash onClick={onDeleteClick} />
    </div>
  )
 }

export default ActionButtons
